import { render, staticRenderFns } from "./InsertWithdraw.vue?vue&type=template&id=287e853d"
import script from "./InsertWithdraw.vue?vue&type=script&lang=js"
export * from "./InsertWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports